"use strict";
var _a, _b, _c;
Object.defineProperty(exports, "__esModule", { value: true });
exports.sharedMessages = exports.fallbackLocale = exports.defaultLocale = void 0;
var de_json_1 = require("../i18n/de.json");
var en_json_1 = require("../i18n/en.json");
exports.defaultLocale = (_c = (_b = (_a = window.ocm) === null || _a === void 0 ? void 0 : _a.config) === null || _b === void 0 ? void 0 : _b.language) !== null && _c !== void 0 ? _c : "de";
exports.fallbackLocale = "en";
exports.sharedMessages = { de: de_json_1.default, en: en_json_1.default };
